import { useEffect } from 'react';

import { usePostVideoReport } from '@vimeo/gctl-api/hooks/useVideoReport';
import { Reason, VideoReason } from '@vimeo/report-modal';

export interface ReportProps {
  clipId?: string;
  onFailure?: () => void;
  onSuccess?: () => void;
}

export function usePostReport({ clipId, onFailure, onSuccess }: ReportProps) {
  const [post, { called, error, loading }] = usePostVideoReport();

  useEffect(
    function registerResult() {
      if (!called || loading) return;

      if (!!error) {
        onFailure?.();
      } else {
        onSuccess?.();
      }
    },
    [called, error, loading, onFailure, onSuccess],
  );

  const postReport = async (reportReason: Reason, reportComment?: string) => {
    if (!clipId || !reportReason || reportReason === 'unselected') {
      return;
    }

    await post({
      where: {
        videoId: Number(clipId),
      },
      variables: {
        comment: reportComment,
        reason: reportReason as VideoReason,
      },
    });
  };

  return { isPosting: loading, postReport };
}
